import type { TFunction } from 'i18next';

import { toast } from '@nucleus-commerce/ui/components/sonner';

/** Clipboard write with the docs' copied / failed toasts. */
export async function copyText(text: string, t: TFunction<'docs'>): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(t('mdx.copied'));
  } catch {
    toast.error(t('mdx.copyFailed'));
  }
}
